// Parsing & format jumlah halaman berbasis pecahan (1/4, 1/2, 3/4, 1, 2 1/2, 1.5)
export const HALAMAN_HINT = 'Ketik jumlah halaman: 1/4 jika seperempat halaman, 1/2 jika setengah halaman, 3/4 jika tiga perempat, 1 jika satu halaman penuh. Gunakan / bukan koma.';

export function parseHalaman(input) {
  if (typeof input === 'number') return isFinite(input) ? input : null;
  const s = String(input ?? '').trim();
  if (!s) return null;
  if (s.includes(',')) return null;
  const mixed = s.match(/^(\d+)?\s*(?:(\d+)\s*\/\s*(\d+))?$/);
  if (mixed && (mixed[1] || mixed[2])) {
    const whole = mixed[1] ? parseInt(mixed[1], 10) : 0;
    const den = mixed[3] ? parseInt(mixed[3], 10) : 1;
    if (den === 0) return null;
    const frac = mixed[2] ? parseInt(mixed[2], 10) / den : 0;
    return whole + frac;
  }
  if (/^\d+(\.\d+)?$/.test(s)) return parseFloat(s);
  return null;
}

const FRACTIONS = [[1/3, '1/3'], [0.25, '¼'], [0.5, '½'], [0.75, '¾']];

export function formatHalaman(num) {
  const n = Number(num) || 0;
  const whole = Math.floor(n);
  const rem = n - whole;
  if (rem < 0.01) return String(whole);
  const hit = FRACTIONS.find(([v]) => Math.abs(rem - v) < 0.01);
  if (hit) return whole > 0 ? `${whole} ${hit[1]}` : hit[1];
  return String(Math.round(n * 100) / 100);
}

// Nilai awal yang bisa diedit di input teks (dari angka tersimpan)
export function halamanToInput(num) {
  if (num === null || num === undefined || num === '') return '';
  const n = Number(num);
  if (!isFinite(n) || n === 0) return '';
  const whole = Math.floor(n);
  const rem = n - whole;
  const map = { [1/3]: '1/3', 0.25: '1/4', 0.5: '1/2', 0.75: '3/4' };
  const key = Object.keys(map).find(k => Math.abs(rem - Number(k)) < 0.01);
  if (rem < 0.01) return String(whole);
  if (key) return whole > 0 ? `${whole} ${map[key]}` : map[key];
  return String(n);
}

// ─── Ziyadah: pilihan bertahap kelipatan 1/4 halaman (Bagian 2) ──
export const ZIYADAH_HINT = '1/4 jika seperempat halaman, 1/2 jika setengah halaman, 1 jika satu halaman penuh, gunakan kelipatan 1/4.';

// Daftar opsi { value: number, label: string } dari 1/4 s/d maxPages (default 10)
export function ziyadahOptions(maxPages = 10) {
  const opts = [];
  for (let q = 1; q <= maxPages * 4; q++) {
    const val = q / 4;
    opts.push({ value: val, label: halamanToInput(val) });
  }
  return opts;
}

// ─── Deskripsi rentang setoran (Juz + halaman, fallback ke surah lama) ──
export function describeSetoran(s) {
  if (!s) return '—';
  if (s.juz != null && s.juz !== '') {
    const range = (s.dari_halaman != null && s.sampai_halaman != null)
      ? ` · Hal. ${s.dari_halaman}–${s.sampai_halaman}`
      : (s.dari_halaman != null ? ` · Hal. ${s.dari_halaman}` : '');
    return `Juz ${s.juz}${range}`;
  }
  // Data lama berbasis surah/ayat
  const surah = s.dari_surah_nama || s.surah_nama;
  if (surah) {
    const ayat = s.dari_ayat != null
      ? ` Q.${s.dari_ayat}${s.sampai_surah_nama ? ` → ${s.sampai_surah_nama} Q.${s.sampai_ayat}` : ''}`
      : (s.ayat_awal != null ? ` ${s.ayat_awal}–${s.ayat_akhir}` : '');
    return `${surah}${ayat}`;
  }
  return '—';
}

// ─── Label sesi absensi ──
export const SESI_LABEL = { sore: 'Sesi 1 · Sore', malam: 'Sesi 2 · Malam' };
export const SESI_SHORT = { sore: 'S1', malam: 'S2' };
